import type { RegisteredComponent } from "@builder.io/sdk-react";

import { useAuth } from "~/hec/context/auth-context";

interface AuthContentProps {
  children?: React.ReactNode;
  attributes?: Record<string, unknown>;
}

/**
 * AuthContent — conditional wrapper that only renders children when the user
 * IS logged in. Used inside Builder content (e.g. Account Dropdown) to show
 * authenticated-user UI such as account links, perks, and sign-out.
 */
const AuthContent = ({ children, attributes }: AuthContentProps) => {
  const { isLoggedIn } = useAuth();
  if (!isLoggedIn) return null;
  return <div {...attributes}>{children}</div>;
};

export const AuthContentDefinition = {
  component: AuthContent,
  name: "AuthContent",
  noWrap: true,
  canHaveChildren: true,
  image: "https://unpkg.com/css.gg@2.0.0/icons/svg/user.svg",
  inputs: [],
} satisfies RegisteredComponent;

export default AuthContent;
